export const uiConstants = {
  SCREEN_RESIZE: 'UI_SCREEN_RESIZE',
};
